import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/** Data curta do detalhe do perfil no `Galeria.dc.html`: "28 jul. 2026" (o `ptBR` abrevia o mês sem o ponto). */
export function dataCurta(time: number | string | Date) {
  return format(new Date(time), "d MMM'.' yyyy", { locale: ptBR });
}
